import { confirmPasswordReset, verifyPasswordResetCode } from "firebase/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SchoolLogo from '../assets/images/logo.png';
import { ButtonStatus } from "../common/constants";
import Button from "../components/Button";
import FooterLayout from "../components/layouts/FooterLayout";
import { auth } from "../firebase";
import style from "./LoginAccess.module.css";

const ActionHandler = () => {
    const navigate = useNavigate();
    const [oobCode] = useState(() => new URLSearchParams(window.location.search).get('oobCode'));
    const [mode] = useState(() => new URLSearchParams(window.location.search).get('mode'));
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const [verifying, setVerifying] = useState(true);
    const [linkNotValid, setLinkNotValid] = useState(false);
    const [saving, setSaving] = useState(false);
    const [completed, setCompleted] = useState(false);

    useEffect(() => {
        let active = true;
        async function verifyCode() {
            try {
                if (auth.currentUser) await auth.signOut();
                if (!oobCode || mode !== 'resetPassword') {
                    if (active) setLinkNotValid(true);
                    return;
                }
                await verifyPasswordResetCode(auth, oobCode);
            } catch {
                if (active) setLinkNotValid(true);
            } finally {
                if (active) setVerifying(false);
            }
        }
        verifyCode();
        return () => { active = false; };
    }, [oobCode, mode]);

    const handlePasswordReset = async (event) => {
        event.preventDefault();
        if (saving || verifying || linkNotValid || completed) return;
        if (password !== repeatPassword) {
            setError('Le password non coincidono.');
            return;
        }
        setSaving(true);
        setError(null);
        try {
            await confirmPasswordReset(auth, oobCode, password);
            setCompleted(true);
            setPassword('');
            setRepeatPassword('');
        } catch (error) {
            if (['auth/expired-action-code', 'auth/invalid-action-code'].includes(error.code)) {
                setLinkNotValid(true);
            } else {
                setError(error.code === 'auth/weak-password'
                    ? 'Scegli una password più sicura, rispettando i requisiti richiesti.'
                    : 'Impossibile aggiornare la password. Riprova tra poco.');
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <FooterLayout>
            <main className={style.page}>
                <section className={style.card} aria-labelledby="action-title" aria-busy={verifying}>
                    <img src={SchoolLogo} alt="Starting Finance Business School" className={style.logo} />
                    <header className={style.heading}>
                        <span className={style.eyebrow}>Backoffice</span>
                        <h1 id="action-title">{verifying ? 'Verifica del link' : completed ? 'Password aggiornata' : linkNotValid ? 'Link non valido' : 'Imposta la nuova password'}</h1>
                        <p>{verifying ? 'Stiamo verificando il link di recupero.' : completed
                            ? 'Puoi accedere al backoffice di Starting Finance Business School con la nuova password.'
                            : linkNotValid ? 'Il link è scaduto, è già stato utilizzato o non è valido. Torna all’accesso per richiederne uno nuovo.'
                            : 'Scegli una nuova password per il tuo account Starting Finance Business School.'}</p>
                    </header>
                    {!verifying && !linkNotValid && !completed && <form className={style.form} onSubmit={handlePasswordReset}>
                        <div className={style.field}>
                            <label htmlFor="new-password">Nuova password</label>
                            <span className={style.passwordField}>
                                <input id="new-password" type={showPassword ? 'text' : 'password'} autoComplete="new-password" placeholder="Inserisci la nuova password" value={password} onChange={event => { setPassword(event.target.value); setError(null); }} required disabled={saving} />
                                <button type="button" aria-label={showPassword ? 'Nascondi password' : 'Mostra password'} aria-pressed={showPassword} onClick={() => setShowPassword(value => !value)}>{showPassword ? 'Nascondi' : 'Mostra'}</button>
                            </span>
                        </div>
                        <label className={style.field}>Conferma password
                            <input type={showPassword ? 'text' : 'password'} autoComplete="new-password" placeholder="Ripeti la nuova password" value={repeatPassword} onChange={event => { setRepeatPassword(event.target.value); setError(null); }} required disabled={saving} />
                        </label>
                        {error && <div className={style.error} role="alert">{error}</div>}
                        <Button type="submit" requiresEdit={false} disabled={saving || !password || !repeatPassword} status={saving ? ButtonStatus.Loading : null}>Salva password</Button>
                    </form>}
                    <div className={style.methods}>
                        <Button appearance="subtle" disabled={saving} onClick={() => navigate('/login')}>Torna all’accesso</Button>
                    </div>
                </section>
            </main>
        </FooterLayout>
    );
};

export default ActionHandler;
